<template>
  <div class="uploadFile-box">
    <div v-if="!disabled" class="tips">
      <slot></slot>
    </div>
    <el-upload
      v-if="!disabled"
      class="upload-file-form"
      ref="uploadFile"
      multiple
      :headers="header"
      :action="uploadUrl + action"
      :accept="accept"
      :on-success="handleFileSuccess"
      :before-upload="beforeFileUpload"
      :on-remove="handleRemoveFile"
      :on-preview="viewFile"
      :on-progress="handleProgress"
    >
      <!--  :on-remove="handleRemoveFile" -->
      <el-button size="small" type="primary">点击上传</el-button>
      <!-- <i class="el-icon-plus"></i> -->
    </el-upload>
    <!-- <div v-if="!disabled" class="tips">
        <slot></slot>
      </div> -->
    <div
      class="file-item"
      v-for="(file, index) in imgList"
      :key="file.uploadFileId"
    >
      <el-image
        v-if="updateView"
        class="file-img"
        :src="getOssImgUrl(file)"
        fit="cover"
      />

      <span class="type-icon" v-if="file.fileType.indexOf('video') !== -1">
        <i class="el-icon-video-play"></i>
      </span>
      <span class="upload-action">
        <span @click="viewFile(file)">
          <i class="el-icon-zoom-in"></i>
        </span>
        <span @click="downLoad(file)">
          <i class="el-icon-download"></i>
        </span>
        <span v-if="!disabled" @click="handleRemoveFile(file, 1)">
          <i class="el-icon-delete"></i>
        </span>
      </span>
    </div>

    <div
      v-for="(file, index) in docList"
      :key="file.uploadFileId"
      class="file-list"
    >
      <div>
        <i
          class="el-icon-document"
          style="margin-right: 7px; color: #909399"
        ></i>
        <span class="file-name">{{ file.fileName }}</span>
      </div>
      <div style="margin-left: 10px">
        <el-button
          type="text"
          size="small"
          style="padding: 0"
          @click="downLoad(file)"
          >下载</el-button
        >
        <!-- <el-button
              type="text"
              size="small"
              style="padding:0"
              v-if="showViewBtn(file.fileType)"
              @click="viewFile(file)"
              >预览</el-button
            > -->
        <el-button
          type="text"
          size="small"
          style="color: red; padding: 0"
          v-if="!disabled"
          @click="handleRemoveFile(file, 2)"
          >删除</el-button
        >
      </div>
    </div>
    <div v-if="disabled && (!fileList || fileList.length === 0)">无</div>
    <div v-for="file in fileListIng" :key="file.uid" class="file-list">
      <div style="width: 250px; position: relative">
        <div class="file-name-box">
          <i
            class="el-icon-document"
            style="margin-right: 7px; color: #909399"
          ></i>
          <span class="file-name">{{ file.name }}</span>
        </div>
        <el-progress class="progress" :percentage="file.progress"></el-progress>
      </div>
    </div>
    <view-img-video ref="viewRef" />
  </div>
</template>

<script>
import { totalSum } from "@/util/totalSum";
import ViewImgVideo from "@/components/viewImgVideo.vue";
import { uploadUrl } from "@/util/url";

export default {
  name: "file-upload",
  components: { ViewImgVideo },
  model: {
    prop: "fileList",
    event: "c-change"
  },
  props: {
    // 上传文件数组
    fileList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 上传地址
    action: {
      type: String,
      default: ""
    },
    accept: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    imgLimit: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      uploadUrl,
      uploading: false, // 上传状态
      updateView: true,
      header: {
        satoken: sessionStorage.getItem("token")
      }, // 上传
      fileListIng: [],
      max: 500, // 上传
      sum: 0, // 上传
      imgList: [],
      docList: []
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.fileList) this.getFileType();
    });
  },
  methods: {
    clearfile() {
      console.log("调用成功");
      this.$refs.uploadFile.clearFiles();
      this.$refs.uploadFile.uploadFiles = [];
      this.imgList = [];
      this.docList = [];
    },
    // 区分两个文件类型
    getFileType() {
      this.fileList.map(item => {
        let fileExtension = item.fileType.slice(0, 5);
        if ("image,video".indexOf(fileExtension) !== -1) {
          this.imgList.push(item);
        } else {
          this.docList.push(item);
        }
      });
    },
    // 上传进度
    handleProgress(event, file, fileList) {
      const index = this.fileListIng.findIndex(item => {
        return item.uid === file.uid;
      });
      if (index != -1) {
        this.fileListIng[index].progress = parseInt(event.percent);
      }
    },
    // 删除上传文件
    handleRemoveFile(file, type) {
      if (type == 1) {
        this.imgList.map((pic, i) => {
          if (pic.uploadFileId == file.uploadFileId) {
            this.imgList.splice(i, 1);
            this.updateView = false;
            this.$nextTick(() => {
              this.updateView = true;
            });
          }
        });
      } else {
        this.docList.map((pic, i) => {
          if (pic.uploadFileId == file.uploadFileId) {
            this.docList.splice(i, 1);
            this.updateView = false;
            this.$nextTick(() => {
              this.updateView = true;
            });
          }
        });
      }
      this.fileList.map((pic, i) => {
        if (pic.uploadFileId == file.uploadFileId) {
          this.fileList.splice(i, 1);
          this.updateView = false;
          this.$nextTick(() => {
            this.updateView = true;
          });
        }
      });
      this.$emit("delChange", file);
      this.$emit("c-change", this.fileList);
    },
    // 上传之前
    beforeFileUpload(file) {
      this.fileListIng.push({
        uid: file.uid,
        name: file.name,
        progress: 0
      });
      this.uploading = true;
      let total = 0;
      total = this.sum + file.size / 1024 / 1024;
      // console.log(total)
      if (total >= this.max) {
        this.$DonMessage.warning("您上传的文档已超过最高限制500M");
        this.uploading = false;
        return false;
      }
      const imgLt = this.imgLimit || 500;
      const videoLt = 500;
      const xlsLt = 500;
      const docLt = 500;
      let limit = 0;
      let isLt = 0;
      // 图片
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSvg = file.type === "image/svg+xml";
      let isImg = false;
      if (isJPG || isPNG || isSvg) {
        isImg = true;
      }
      if (isImg) {
        limit = imgLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.uploading = false;
          this.$DonMessage.warning("上传图片大小不能超过 500MB!");
          this.fileListIng.splice(
            this.fileListIng.findIndex(item => {
              return item.uid === file.uid;
            }),
            1
          );
        }

        return isImg && isLt;
      }

      // 视频
      const isMP4 = file.type === "video/mp4";
      const is3GP = file.type === "video/3gpp";
      const isMOV = file.type === "video/quicktime";
      const isM4V = file.type === "";
      let isVideo = false;
      if (isMP4 || is3GP || isMOV) {
        isVideo = true;
      }
      if (isVideo) {
        limit = videoLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.$DonMessage.warning("上传视频大小不能超过 500MB!");
          this.uploading = false;
          this.fileListIng.splice(
            this.fileListIng.findIndex(item => {
              return item.uid === file.uid;
            }),
            1
          );
        }
        return isVideo && isLt;
      }

      // 表格
      const isXLS =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (isXLS) {
        limit = xlsLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.$DonMessage.warning("上传表格大小不能超过 500MB!");
          this.fileListIng.splice(
            this.fileListIng.findIndex(item => {
              return item.uid === file.uid;
            }),
            1
          );
          this.uploading = false;
        }

        return isXLS && isLt;
      }

      // 文档
      const isDOC = file.type === "application/msword";
      const isDOCX =
        file.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      const isPDF = file.type === "application/pdf";
      let isFile = false;
      if (isDOC || isDOCX || isPDF) {
        isFile = true;
      }
      if (isFile) {
        limit = docLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.$DonMessage.warning("上传文档大小不能超过 500MB!");
          this.fileListIng.splice(
            this.fileListIng.findIndex(item => {
              return item.uid === file.uid;
            }),
            1
          );
          this.uploading = false;
        }
        return isFile && isLt;
      }
    },
    // 上传成功
    handleFileSuccess(res, file) {
      this.fileListIng.splice(
        this.fileListIng.findIndex(item => {
          return item.uid === file.uid;
        }),
        1
      );
      if (res.status == 0) {
        let data = res.data;
        let obj = {
          uploadFileId: data.uploadFileId,
          uploaderId: data.uploaderId,
          fileName: data.fileName,
          fileSize: data.fileSize,
          fileType: data.fileType,
          filePath: encodeURI(data.filePath),
          fileSource: data.fileSource,
          name: data.fileName,
          url: encodeURI(data.filePath)
        };
        this.fileList?.push(obj);
        let fileExtension = obj.fileType.slice(0, 5);
        if ("image,video".indexOf(fileExtension) !== -1) {
          this.imgList.push(obj);
        } else {
          this.docList.push(obj);
        }
        this.$emit("c-change", this.fileList);
        const total = totalSum(this.fileList, "fileSize");
        this.sum = total / 1024;
      } else {
        this.$DonMessage.error(res.message);
        let uid = file.uid; // 关键作用代码，去除文件列表失败文件
        let idx = this.$refs.uploadFile.uploadFiles.findIndex(
          item => item.uid === uid
        );
        this.$refs.uploadFile.uploadFiles.splice(idx, 1);
      }
    },
    // 下载
    downLoad({ filePath }) {
      window.open(filePath);
    },
    // 预览
    viewFile(file) {
      this.$refs.viewRef.init(file);
    },
    // 预览按钮显示
    showViewBtn(type) {
      const fileExtension = type.slice(0, 5);
      return "image,video".indexOf(fileExtension) !== -1;
    },
    //
    getOssImgUrl({ fileType, filePath }) {
      if (fileType.indexOf("image") != -1) {
        return `${filePath}?x-oss-process=image/resize,w_424`;
      } else {
        return `${filePath}?x-oss-process=video/snapshot,t_1,m_fast,w_424`;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-file-form {
  // display: inline-block;
  ::v-deep .el-upload {
    vertical-align: unset;
    margin-right: 20px;
  }
  ::v-deep .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }
}

.file-item {
  display: inline-block;
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 6px;
  overflow: hidden;
  margin-right: 20px;
  .file-img {
    width: 100%;
    height: 100%;
  }
  .type-icon {
    position: absolute;
    top: 8px;
    left: 8px;
    line-height: 0;
    font-size: 20px;
    color: #fff;
    background: #747474;
  }
  .upload-action {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    cursor: default;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
  }
  .upload-action:hover {
    opacity: 1;
  }
  .upload-action span {
    cursor: pointer;
  }
  .upload-action span + span {
    margin-left: 15px;
  }
}

::v-deep .el-upload-list {
  display: none;
}
.tips {
  // margin-top: -20px;
  line-height: 20px;
  color: #cecece;
  font-size: 12px;
}
.file-name-box {
  overflow: hidden; /* 确保超出容器的文本被隐藏 */
  white-space: nowrap; /* 确保文本在一行内显示 */
  text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
  margin-right: 50px;
}
.progress {
  position: absolute;
  top: 22px;
  width: 100%;
  ::v-deep {
    .el-progress-bar {
      margin-right: 0;
      padding-right: 0;
    }
    .el-progress__text {
      position: absolute;
      right: 0;
      top: -10px;
    }
    .el-progress-bar__outer {
      height: 2px !important;
    }
  }
}
::v-deep .el-upload-dragger {
  width: 100%;
  height: 100%;
}
</style>
<style lang="scss" scoped>
.is-error {
  .upload-file-form {
    .el-upload-dragger {
      border-color: #f56c6c;
    }
  }
}
.file-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 26px;
  padding-left: 4px;
  margin-top: 5px;
  .file-name {
    color: #606266;
  }
}
::v-deep .el-upload-list {
  display: none;
}
</style>
